module.exports = __webpack_public_path__ + "static/media/7ab680db-f014-4d31-b59e-26b2b5c2c9dc.39b3a7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/7ab680db-f014-4d31-b59e-26b2b5c2c9dc.png
// module id = 1454
// module chunks = 0